import { Icon } from '@iconify/react'
import { BooleanParam, useQueryParam } from 'use-query-params'
import { useParams } from 'react-router-dom'
import { useModal } from '@ebay/nice-modal-react'

import {
  Button,
  Dropdown,
  Tooltip,
  useGetProjectDomain,
  useGlobalState,
} from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'

import CTACard from 'container/Projects/LiveProjects/CTACard'

import s from './CreateTopicsDropdown.module.css'

type Props = {
  onDiscoverTopics: () => void
  onImportTopics: () => void
}

export const CreateTopicsDropdown = ({
  onDiscoverTopics,
  onImportTopics,
}: Props) => {
  const companyId = useSelectedCompanyId()
  const [_, setOpenLinkDomainModal] = useQueryParam('link_domain', BooleanParam)
  const { permissions } = useGlobalState()
  const { projectId } = useParams<{ projectId: string }>()
  const { show: showUpsellBanner } = useModal('buy-cmp')
  const { data: projectDomain } = useGetProjectDomain({
    data: {
      companyId,
      projectId,
    },
  })

  const isDomainLinked = !!projectDomain?.domain
  const isDomainRemoved = !!projectDomain?.domain?.deleted_at
  const hasTopicsPermission = permissions?.topics

  const menu = (
    <div className={s.wrapper}>
      <CTACard
        title="Discover Topics ->"
        description="Dive into a sea of content ideas curated for you, or create your very own! 💡"
        icon={<Icon icon="lucide:loader" width={20} height={20} />}
        onClick={onDiscoverTopics}
      />
      <CTACard
        title="Import your Topics ->"
        description="Have a list ready? 📋 Create keywords, SEO briefs, and start writing!"
        icon={<Icon icon="uil:file-upload-alt" width={20} height={20} />}
        onClick={onImportTopics}
      />
    </div>
  )

  return (
    <>
      {isDomainLinked && isDomainRemoved && (
        <Tooltip
          title="Domain associated with this project has been removed"
          placement="left"
        >
          <Button
            type="primary"
            icon={<Icon icon="lucide:plus" width={16} height={16} />}
            className={s.disabledBtn}
          >
            Add Topics
          </Button>
        </Tooltip>
      )}
      {!isDomainLinked && hasTopicsPermission && (
        <Button
          type="primary"
          icon={<Icon icon="lucide:plus" width={16} height={16} />}
          onClick={() => setOpenLinkDomainModal(true)}
        >
          Add Topics
        </Button>
      )}
      {!hasTopicsPermission && !isDomainRemoved && (
        <Button
          type="primary"
          icon={<Icon icon="lucide:plus" width={16} height={16} />}
          onClick={() => showUpsellBanner({ id: 'topics' })}
        >
          Add Topics
        </Button>
      )}
      {hasTopicsPermission && isDomainLinked && !isDomainRemoved && (
        <Dropdown overlay={menu} trigger={['click']} disabled={isDomainRemoved}>
          <Button
            type="primary"
            icon={<Icon icon="lucide:plus" width={16} height={16} />}
          >
            Add Topics
          </Button>
        </Dropdown>
      )}
    </>
  )
}
